import { useQuery } from '@tanstack/react-query';
import { marketService } from 'shared/src/api';
import { isNotNil } from 'shared/src/utils';
import { useGoodsBasic } from '../../../../../queries/useGoodsBasic';
import { queryKey } from '../../../../../constant/queryKey';

// 네이티브 state.aiStudioProductInfo 대응. market-scoped API 라 marketSno 로 조회.
// (marketSno 는 goodsBasic.market.sno)
export const useAiStudioProductInfo = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const marketSno = goodsBasic?.market.sno;

  return useQuery({
    queryKey: queryKey.aiStudioProductInfo(marketSno ?? 0),
    queryFn: () => marketService.getAiStudioProductInfo(marketSno as number),
    enabled: isNotNil(marketSno),
  });
};
